/**
 * Locale trimmed to language enum
 */
export enum Language {
  ENGLISH = 'en',
  FRENCH = 'fr',
  SPANISH = 'es',
  CATALAN = 'ca',
  GERMAN = 'de',
}
